module.exports = __webpack_public_path__ + "static/media/block-2_9_.a5f4c7d9.svg";